import * as rrd from 'react-router-dom';

import { DevStageIndicator } from '@/components';

const { Link, useLocation } = rrd.default ?? rrd;

const Navigation = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 border-bottom">
      <div className="container">
        <Link to="/" className="navbar-brand fw-bold">
          Convert Playlist
          <DevStageIndicator />
        </Link>

        <button
          type="button"
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/history" className="nav-link">
                History
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
